// React
import React, {Component} from 'react';
// Translations
import {withTranslation} from "react-i18next";
// Styles
import './styles.scss';
// Img
import maintenance_img from "@img/centribot_gym.png";

class Maintenance extends Component {
    render() {
        const {t} = this.props;
        return (
            <div className={"platform_maintenance"}>
                <div className={"platform_maintenance_content"}>
                    <span className={"platform_maintenance_title"}>{t('maintenance.title')}</span>
                    <span className={"platform_maintenance_description"}>
                        <b>Bots</b>
                        <span dangerouslySetInnerHTML={{__html: t('maintenance.description')}}/>
                    </span>
                </div>
                <img className={"platform_maintenance_watermark"} src={maintenance_img}
                     alt={"platform_maintenance_watermark"}/>
            </div>
        );
    }
}

export default withTranslation('commons')(Maintenance);